export function LoadingScreen({ label }: { label: string }): React.JSX.Element {
  return (
    <main className="fr-loading">
      <div className="fr-loading-content">
        <img
          className="fr-loading-mark"
          src="/img/logo-header.png"
          alt=""
          width="72"
          height="72"
        />
        <div className="fr-loading-brand">Fairway Rivalry</div>
        <h1 className="fr-loading-title">
          Every rivalry starts
          <br />
          with <em>one round.</em>
        </h1>
        <div className="fr-loading-line" aria-hidden="true" />
        <p role="status" className="fr-loading-status">
          {label}
        </p>
      </div>
    </main>
  );
}
